export default __webpack_public_path__ + "static/media/Sridisha.9122ccd7.jpeg";